import { LISTENER_EVENT_ALIASES } from './event-map'

const norm = (s: string): string => String(s ?? '').trim().toLowerCase()

/** IKeys.TREE_DROP / IKeys.ON_DROP (SwingTreeTable.addActionElement). */
const TREE_DROP_NAMES = ['onDrop', '_treeDrop']

/** Selection-related event/action names. */
const SELECTION_CLUSTER = [
  'selectionChanged',
  'onSelectionChanged',
  'onSelectionChange',
  'selectionChange',
]

export function eventActionNameCandidates(firedEventName: string): string[] {
  const out = new Set<string>()
  const raw = String(firedEventName ?? '').trim()
  if (raw) out.add(raw)

  const low = norm(raw)

  if (low === 'ondrop' || low === '_treedrop' || TREE_DROP_NAMES.some((n) => norm(n) === low)) {
    TREE_DROP_NAMES.forEach((n) => out.add(n))
  }

  if (SELECTION_CLUSTER.some((n) => norm(n) === low)) {
    SELECTION_CLUSTER.forEach((n) => out.add(n))
  }

  for (const [aliasKey, aliasVals] of Object.entries(LISTENER_EVENT_ALIASES)) {
    const keys = [aliasKey, ...aliasVals]
    if (keys.some((k) => norm(k) === low)) {
      out.add(aliasKey)
      aliasVals.forEach((v) => out.add(v))
    }
  }

  return [...out]
}

function closureExpand(seed: string[]): string[] {
  const acc = new Set(seed)
  let prev = -1
  while (acc.size !== prev) {
    prev = acc.size
    for (const n of [...acc]) {
      eventActionNameCandidates(n).forEach((c) => acc.add(c))
    }
  }
  return [...acc]
}

export function expandActionNamesForEventsProp(actionNameFromMetadata: string): string[] {
  return closureExpand([String(actionNameFromMetadata ?? '').trim()].filter(Boolean))
}
